import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Icon, Button, Input } from '../Elements';

import classes from './TableFilterFromTo.module.scss';

const TableFilterFromToOld = ({ fromTo, handleFromTo, field = '' }) => {
  const maxValue = fromTo?.[`${field}To`];
  const minValue = fromTo?.[`${field}From`];
  return (
    <div className={classes.filter}>
      <Icon
        size="16px"
        icon="filter"
        className={cn(
          classes.filter_icon,
          fromTo?.[`${field}From`] !== '' || fromTo?.[`${field}To`] !== ''
            ? classes.filter_icon__active
            : ''
        )}
      />
      <div className={classes.filter_tooltip}>
        <Input
          input={{ value: minValue, onChange: handleFromTo }}
          placeholder="From"
          className={classes.filter_tooltip__input}
          name={`${field}From`}
          type={'number'}
        />
        <span className={classes.filter_tooltip__minus}>{' - '}</span>
        <Input
          input={{ value: maxValue, onChange: handleFromTo }}
          placeholder="To"
          className={classes.filter_tooltip__input}
          name={`${field}To`}
          type={'number'}
        />
        <Button
          className={classes.close}
          onClick={handleFromTo}
          aria-label={`clear filter`}
          id={field}
        >
          <Icon icon="closeCircle" className={classes.close_icon} size="16px" />
        </Button>
      </div>
    </div>
  );
};

TableFilterFromToOld.propTypes = {
  fromTo: PropTypes.object.isRequired,
  handleFromTo: PropTypes.func.isRequired,
  field: PropTypes.string
};

export default TableFilterFromToOld;
